import "./chatbot.css";
import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import minimize from "../../assets/images/minimize 1.svg";
import closeChat from "../../assets/images/closeChat.svg";
import profileIcon from "../../assets/images/userIcon.png";
import iconSend from "../../assets/images/iconSend.svg";
import Logo from "../../assets/images/logo.webp";
import botIcon from "../../assets/images/icon-chat-message.svg";
import AutoTyping from "./autoTyping";
import { loader } from "../../Utilities/loader";

import chatService from "../../services/chatService";
import { tokenRefreshService } from "../../services/tokenRefreshService";

function Chatbot() {
  const [options, setOptions] = useState([]);

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const sessionIdRef = useRef("");
  const [isBotTyping, setIsBotTyping] = useState(false);

  const textAreaRef = useRef(null);
  const chatContainerRef = useRef(null);
  const chatEndRef = useRef(null);
  const shouldAutoScrollRef = useRef(true);
  const [typing, setTyping] = useState(false);
  const [chatLoader, setLoader] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [sessionId, setSessionId] = useState("");
  const [agentId, setAgentId] = useState("");
  const [sessionConversation, setSessionConversation] = useState([]);

  useEffect(() => {
    sessionIdRef.current = sessionId;
    loader("stop");
  }, [sessionId]);

  useLayoutEffect(() => {
    var uuid = uuidv4();
    setSessionId(uuid);
    sessionIdRef.current = uuid;
    const messageBody = `💊 Hello! 👋
I am AskEmcure, your virtual health assistant.
I’m here to help you with queries regarding Emcure Pharmaceuticals, our products, and related healthcare services ❤️.

How may I assist you today? 😊`;

    setSessionConversation([{ type: "SYSTEM", body: messageBody }]);
  }, []);

  const extractOptions = (message) => {
    const regex = /OP-\s*([^\n\r]+)/g;
    const matches = [];
    let match;
    while ((match = regex.exec(message)) !== null) {
      matches.push(match[1].trim());
    }
    return matches;
  };

  const handleChatScroll = () => {
    const el = chatContainerRef.current;
    if (!el) return;

    const thresholdPx = 80;
    const distanceFromBottom = el.scrollHeight - (el.scrollTop + el.clientHeight);
    shouldAutoScrollRef.current = distanceFromBottom <= thresholdPx;
  };

  useEffect(() => {
    if (shouldAutoScrollRef.current && chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
    }
  }, [sessionConversation, chatLoader]);

  const uuidv4 = () => {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) =>
      (
        +c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (+c / 4)))
      ).toString(16)
    );
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const createNewSession = () => {
    setTyping(false);
    setIsOpen(!isOpen);
    window.location.reload();
  };

  const minimizeBot = () => {
    window.parent.postMessage({ msg: "minimizeClose" }, "*");
  };

  const closeBot = () => {
    window.parent.postMessage({ msg: "minimize" }, "*");
    setIsOpen(!isOpen);
  };

  const onClickHeaderIcon = () => {
    setIsOpen(!isOpen);
  };

  const handleKeyPress = (event) => {
      if (event.key === "Enter") {
        if (event.shiftKey) {
          event.preventDefault();
        const textarea = event.target;
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;

        const newValue = inputValue.slice(0, start) + "\n" + inputValue.slice(end);
        setInputValue(newValue);

        setTimeout(() => {
          textarea.selectionStart = textarea.selectionEnd = start + 1;
        }, 0);
      } else {
        event.preventDefault();
        if (inputValue.trim() !== "") {
          handleSendMessage(inputValue);
          setInputValue("");
        }
      }
    }
  };
  const sendRequest = () => {
    if (inputValue.trim() !== "") {
      handleSendMessage(inputValue);
    }
  };

  const handleOptionClick = (option) => {
    handleSendMessage(option);
  };

  const handleSendMessage = async (query) => {
    setLoader(true);
    setInputValue("");
    let userRequest = {
      type: "USER",
      body: query,
    };

    setSessionConversation((prevsessionConversation) => [
      ...prevsessionConversation,
      userRequest,
    ]);

    let request = {
      query: query,
      session_id: sessionIdRef.current,
    };

    try {
      // Ensure tokens are valid (and store-token has been called) before hitting the query API
      if (!tokenRefreshService.isTokenValid()) {
        await tokenRefreshService.refreshTokens();
      }

      const response = await chatService.sendQuery(
        query,
        sessionIdRef.current
      );

      setLoader(false);

      let message = response.response;

      message = message.replace(/\n/g, "<br/>");

      const extractedOptions = extractOptions(response.message || "");
      setOptions(extractedOptions);
      setSessionConversation((prev) => [
        ...prev,
        {
          type: "SYSTEM",
          body: message,
        },
      ]);
    } catch (error) {
      setLoader(false);
    }
  };

  useEffect(() => {
    window.handleChatbotOption = (option) => {
      handleOptionClick(option);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- handleOptionClick intentionally omitted to register once
  }, []);

  return (
    <>
      <div id="spinner-loader">
        <div className="spinner"></div>
      </div>
      <>
        <div className="bot-header-container d-flex justify-between">
          <div className="left-header-container">
            <img className="logo" src={Logo} alt="Chatbot logo" />
          </div>
          <div className="right-header-container d-flex">
            <img src={minimize} onClick={minimizeBot} alt="Minimize" />
            <img src={closeChat} onClick={onClickHeaderIcon} alt="Close" />

            {isOpen ? (
              <ul className="settings-dropdown" ref={dropdownRef}>
                <li className="profile-dispname" onClick={createNewSession}>
                  <span>New Session</span>
                </li>
                <li onClick={closeBot} className="profile-dispname">
                  <span>Close</span>
                </li>
              </ul>
            ) : null}
          </div>
        </div>
        <div
          className="bot-main-container"
          ref={chatContainerRef}
          onScroll={handleChatScroll}
        >
          {sessionConversation?.map((message, index) => {
            const extractOptions = (body) => {
              const regex = /OP-\s([^\n\r]+)/g;
              const matches = [];
              let match;
              while ((match = regex.exec(body)) !== null) {
                matches.push(match[1].trim());
              }
              return matches;
            };

            const options =
              message.type === "SYSTEM" ? extractOptions(message.body) : [];

            return (
              <React.Fragment key={index}>
                {message.type === "SYSTEM" ? (
                  <div className="d-flex align-center mT-10">
                    <img className="chat-img" src={botIcon} alt="bot icon" />
                    <div className="bot-block">
                      <div className="bot-msg">
                        <AutoTyping
                          text={message.body}
                          speed={10}
                          setTypingMethod={setIsBotTyping}
                        />
                      </div>
                      {options.length > 0 && (
                        <div className="option-buttons mT-10">
                          {options.map((option, idx) => (
                            <button
                              key={idx}
                              onClick={() => handleOptionClick(option)}
                              className="option-btn"
                            >
                              {option}
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="d-flex align-center mT-25">
                    <div className="user-block">
                      <div className="bot-msg">{message.body}</div>
                    </div>
                    <img
                      className="chat-img"
                      src={profileIcon}
                      alt="user icon"
                    />
                  </div>
                )}
              </React.Fragment>
            );
          })}

          {chatLoader ? (
            <div className="d-flex align-center mT-25">
              <img className="chat-img" src={botIcon} alt="bot icon" />
              <div className="bot-block">
                <div className="bot-loader">
                  <div className="typing-dot"></div>
                  <div className="typing-dot"></div>
                  <div className="typing-dot"></div>
                </div>
              </div>
            </div>
          ) : null}
          <div ref={chatEndRef} />
        </div>
        <div className="bot-footer">
          <div>
            <div className="chat-input-row">
              <textarea
                disabled={typing ? true : false}
                ref={textAreaRef}
                placeholder={typing ? "bot is typing..." : "Ask your question"}
                className="chat-input"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                onKeyDown={handleKeyPress}
              />
            </div>
            <div>
              <img
                className="chatbot-send-button"
                src={iconSend}
                onClick={sendRequest}
                alt="Send"
              />
            </div>
          </div>
        </div>
      </>
    </>
  );
}
export default Chatbot;
